import React, {useEffect, useMemo, useState} from "react";
import useFetch from "@common/hooks/fetch/useFetch";
import Logo from "../assets/image/logo.png";
import Empty from "../assets/image/empty.png";
import RightArrow from "../assets/image/icon_right_sm.svg";
import {Moments} from "@common/utils/date/moments";
import {getAdTvRecentList} from "@common/services/restapi/ad";
import {getAdGlobalMainList} from "@common/services/restapi/forum";
import {getJournalList} from "@common/services/restapi/journal";
import {getPanggoList} from "@common/services/restapi/panggo";
import {getJobEmployeeList} from "@common/services/restapi/job";
import {getStatInfo} from "@common/services/restapi/stat";
import LargeCardVertical from "./set/LargeCardVertical";
import ThemeTab from './component/ThemeTap'
import BtnText from "./component/BtnText";
import YouTube from 'react-youtube';
import BackdropHandler from "./component/BackDropHandler";
//import ECharts from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';
import {PieChart,} from 'echarts/charts';
import {SVGRenderer,} from 'echarts/renderers';
import {getThemeAdList, getThemeList} from "@common/services/restapi/theme";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import AppConnectView from './AppConnectView';
import {convertPath} from "@common/utils/path/linkPath";
import {GridComponent, TooltipComponent} from "echarts/components";
import NoticePopupView from "./notice/NoticeImagePopupView";

function HomePage() {

  return (
    <main id="main">
      <div className="common-header--top">
        <img src={Logo} alt="" className="logo"/>
      </div>

      <RecentTvAd/>

      <Theme/>

      <GlobalAd/>

      <Panggo/>

      {/*<section className="trends">
        <div className="section-header">
          <h5 className="title">광고계 동향</h5>
          <BtnText link={`/lit`} text="전체보기" rightIcon="chevron-right" color="gray"/>
        </div>
        <div className="section-body">
          <div className="thumbnail-wrap">
            <div className="thumbnail-card trends">
              <div className="left-box">
                <h3>AD-Z</h3>
                <p>2022 7/8월호</p>
                <div>VOL.337</div>
              </div>
              <div className="right-box">
                <img src={Sample} alt=""/>
              </div>
            </div>
          </div>
        </div>
      </section>*/}

      <Magazine/>

      <Job/>

      <Stat/>

      <section className="footer">
        <div>
          <h4>
            <span>한국광고총연합회</span>
            <img src={RightArrow} alt=""/>
          </h4>
          <p>ⓒ KFAA All Rights Reserved.</p>
        </div>
      </section>
      <AppConnectView isFullView={false}/>
      {/*<NoticePopupView />*/}
    </main>
  );
}

function RecentTvAd({}) {
  const [adRecentSearch, SetAdRecentSearch] = useState({});
  const {data: adRecentList} = useFetch(() => getAdTvRecentList(adRecentSearch), [adRecentSearch], {});

  return (
    <>
      {
        adRecentList &&
        <section className="new-ad">
          <div className="section-header">
            <h5 className="title">최신 TV CF</h5>
          </div>
          <div className="section-body">
            <div className="thumbnail-wrap">
              <LargeCardVertical
                source={adRecentList.latestAdList}
                link={`/ad/tv/`}
                additionalInfo={false}
                additionalClass="main-list"
              />
            </div>
          </div>
        </section>
      }
    </>
  )
}

function Theme({}) {
  const {data: ThemeList} = useFetch(() => getThemeList(), [], {})

  const [selectedTheme, setSelectedTheme] = useState(null);

  useEffect(() => {
    if (!selectedTheme && ThemeList.recommendAds && ThemeList.recommendAds.length > 0) {
      setSelectedTheme(ThemeList.recommendAds[0].id)
    }
  }, [ThemeList])

  const themeAdSearchQuery = useMemo(() => {
    if (!selectedTheme) return null;
    return {
      id: selectedTheme,
      pageNumber: 1,
      pageSize: 12
    }
  }, [selectedTheme])
  const {data: themeAdList} = useFetch(() => getThemeAdList(themeAdSearchQuery), [themeAdSearchQuery], {})

  return (
    <>
      {
        ThemeList && ThemeList.recommendAds && ThemeList.recommendAds.length > 0 &&
        <section className="theme">
          <div className="section-header">
            <h5 className="title">추천 테마 광고</h5>
            <BtnText link={`/recommend/theme`} text="전체보기" rightIcon="chevron-right" color="gray"/>
          </div>
          <div className="section-body">
            <ThemeTab
              selectedThing={selectedTheme}
              setSelectedThing={setSelectedTheme}
              thingsList={ThemeList.recommendAds}
            />
            {themeAdList && themeAdList.recommendThemeAdList &&
              <>
                <div className="thumbnail-wrap theme">
                  {
                    themeAdList.recommendThemeAdList.map((thing, i) =>
                      <a href={convertPath(`/ad/${thing.adCategory}/${thing.adId}`)} className="thumbnail-list" key={`theme-${i}`}>
                        <LazyLoadImage className="thumbnail-card theme"
                                       src={`${thing.ad.thumbnail.replace('/l/', '/m/',).replace("http:", "https:")}`}/>
                        <div className="text-box">
                          <h4 className="ad-title">{thing.ad.title}</h4>
                          <span className="ad-subtitle">{thing.ad.brand}</span>
                        </div>
                      </a>
                    )
                  }
                </div>
              </>
            }
          </div>
        </section>
      }
    </>
  )
}

function GlobalAd({}) {
  const {data: adGlobalList} = useFetch(() => getAdGlobalMainList(), [], {});

  return (
    <>
      {adGlobalList && adGlobalList.forumTextList && adGlobalList.forumVideoList &&
        <section className="">
          <div className="section-header">
            <h5 className="title">글로벌 크리에이티브</h5>
            <BtnText link={`/forum/text`} text="전체보기" rightIcon="chevron-right" color="gray"/>
          </div>
          <div className="section-body">
            <div className="thumbnail-wrap">
              {adGlobalList && adGlobalList.forumTextList && adGlobalList.forumTextList.map((global, index) => {
                return (
                  <div className="thumbnail-list" key={`global-text-${index}`}>
                    <a href={convertPath("/forum/text/" + global.objectId)}>
                      <div className="thumbnail-card global"
                           style={{backgroundImage: `url("//thumb.ad.co.kr/${global.visual.replace('/l/', '/m/')}")`}}>
                      </div>
                      <div className="text-box">
                        <h4 className="ad-title">{global.headline}</h4>
                        {/*<span className="ad-subtitle">나라</span>*/}
                      </div>
                    </a>
                  </div>
                )
              })}
              {adGlobalList && adGlobalList.forumVideoList && adGlobalList.forumVideoList.map((global, index) => {
                return (
                  <div className="thumbnail-list" key={`global-video-${index}`}>
                    <a href={convertPath("/forum/video/" + global.objectId)}>
                      <div className="thumbnail-card global"
                           style={{backgroundImage: `url("//thumb.ad.co.kr/${global.visual.replace('/l/', '/m/')}")`}}>
                      </div>
                      <div className="text-box">
                        <h4 className="ad-title">{global.headline}</h4>
                        {/*<span className="ad-subtitle">나라</span>*/}
                      </div>
                    </a>
                  </div>
                )
              })}
            </div>
          </div>
        </section>
      }
    </>
  )
}

function Panggo() {
  const [panggoSearch, SetPanggoSearch] = useState({});
  const {data: panggoList} = useFetch(() => getPanggoList(panggoSearch), [panggoSearch], {});
  const [pangoID, setPangoID] = useState('')

  const showEachPangoVideo = (clickedVideo) => {
    setPangoID(clickedVideo.videoId)
  }

  const opts = {
    height: '300px',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const onReady = (event) => {
    event.target.pauseVideo();
  }
  return (
    <>
      {
        panggoList && panggoList.items &&
        <section className="panggo">
          <div className="section-header">
            <h5 className="title">팡고TV</h5>
            <BtnText link={`/pangoList`} text="전체보기" rightIcon="chevron-right" color="gray"/>
          </div>
          <div className="section-body">
            <div className="thumbnail-wrap">
              {panggoList.items.map((i, index) => {
                return (
                  <div className="thumbnail-list">
                    <div className="ad-box large-vertical main-list" onClick={() => showEachPangoVideo(i.id)}
                         key={`panggo-${index}`}>
                      <div className="thumbnail-card-wrapper panggo">
                        <LazyLoadImage className="thumbnail-card" src={`${i.snippet.thumbnails.high['url'].replace("http:", "https:")}`}/>
                      </div>
                      <div className="text-box">
                        <h4 className="ad-title">{i.snippet.title}</h4>
                        <div className="row-box">
                          {/*<div className="view-count">
                            <img src={ViewIcon} alt=""/>
                            <span></span>
                          </div>*/}
                          {/*<img src={Split} alt=""/>*/}
                          <div className="created-date">{Moments.Format(i.snippet.publishedAt, 'yyyy.MM.DD')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {
                pangoID &&
                <BackdropHandler onClick={() => setPangoID('')}>
                  <YouTube videoId={pangoID} opts={opts} iframeClassName="pangoYoutube" onReady={() => onReady}/>
                </BackdropHandler>
              }
            </div>
          </div>
        </section>
      }
    </>
  )
}

function Magazine({}) {
  const [journalSearch, SetJournalSearch] = useState({});
  const {data: journalList} = useFetch(() => getJournalList(journalSearch), [journalSearch], {});

  return (
    <>
      {journalList &&
        <section className="magazine">
          <div className="section-header">
            <h5 className="title">매거진</h5>
            <BtnText link={`/magazine`} text="전체보기" rightIcon="chevron-right" color="gray"/>
          </div>
          <div className="section-body">
            <div className="thumbnail-wrap">
              <LargeCardVertical
                source={journalList.articleList}
                isFullThumbnail={true}
                link={`/magazine/`}
                additionalInfo={true}
                additionalClass="main-list"
              />
            </div>
          </div>
        </section>
      }
    </>
  )
}

function Job({}) {
  const [jobSearch, SetJobSearch] = useState({});
  const {data: jobList} = useFetch(() => getJobEmployeeList(jobSearch), [jobSearch], {});

  return (
    <>
      {
        jobList && jobList.jobList &&
        <section className="job">
          <div className="section-header">
            <h5 className="title">채용정보</h5>
            <BtnText link={`/job`} text="전체보기" rightIcon="chevron-right" color="gray"/>
          </div>
          <div className="section-body">
            <div className="thumbnail-wrap">
              {jobList.jobList.map((job, index) => {
                return (
                  <a href={convertPath(`/job/employee/${job.ukey}`)} className="thumbnail-list job" key={`job-${index}`}>
                    <div className="thumbnail-card job">
                      <div className="left-box">
                        <LazyLoadImage src={`${job.thumbnail.includes('null') ? `${Empty}` : `${job.thumbnail.replace("http:", "https:")}`}`}/>
                      </div>
                      <div className="right-box">
                        <h4 className="title">{job.headline}</h4>
                        <div className="company">{job.corpName}</div>
                        <p className="welfare">{job.description}</p>
                        <div className="career">
                          {job.experienceLevel === 0 ? '무관' : job.experienceLevel === 1 ? '신입' : job.experienceLevel === 2 ? "경력 1년이상" : job.experienceLevel === 3 ? "경력 2년이상" : job.experienceLevel === 4 ? '경력 3년이상' : job.experienceLevel === 5 ? '경력 4년이상' : job.experienceLevel === 6 ? '경력 5년이상' : job.experienceLevel === 7 ? ' 경력 6년이상' : job.experienceLevel === 8 ? ' 경력 7년이상' : job.experienceLevel === 9 ? '경력 8년이상' : job.experienceLevel === 10 ? '경력 9년이상' : job.experienceLevel >= 11 ? '경력 10년이상' : '무관'}
                        </div>
                      </div>
                    </div>
                  </a>
                )
              })}
            </div>
          </div>
        </section>
      }
    </>
  )
}

function Stat({}) {
  // Register the required components
  echarts.use(
    [PieChart, GridComponent, TooltipComponent, SVGRenderer]
  );

  const searchQuery = useMemo(() => {
    return {
      className: 'IndustryAdOutlay',
    }
  }, []);

  const {data: {newsArr, magazineArr, tvArr, radioArr,sMonth, sYear}} = useFetch(async () => {
    const data = await getStatInfo(searchQuery);
    const {resultList, smonth, syear} = data;
    const newsArr = [];
    const magazineArr = [];
    const tvArr = [];
    const radioArr = [];

    data.resultList.forEach((item) => {
      newsArr.push(item.newspaper);
      magazineArr.push(item.magazine);
      tvArr.push(item.tv);
      radioArr.push(item.radio);
    });

    return {
      sMonth: smonth,
      sYear:syear,
      newsArr,
      magazineArr,
      tvArr,
      radioArr,
    };
  }, [searchQuery], {newsArr: [], magazineArr: [], tvArr: [], radioArr: [],});

  const Chart = () => {

    const [options, setOptions] = useState({
      color: ['#37D2F4', '#5388D8', '#F4BE37', '#FF9F40'],
      tooltip: {
        trigger: 'item',
      },
      grid: {
        containLabel: true
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: [
        {
          type: 'pie',
          data: [
            {
              value: magazineArr,
              name: '잡지'
            },
            {
              value: newsArr,
              name: '신문'
            },
            {
              value: tvArr,
              name: 'TV'
            },
            {
              value: radioArr,
              name: '라디오'
            },
          ],
          radius: ['40%', '80%'],
          avoidLabelOverlap: true,
          label: {
            show: false,
            position: 'center'
          },
          itemStyle: {
            borderRadius: 10,
            borderWidth: 2
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '16',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
        },
      ]
    });

    return (
      <ReactEChartsCore
        echarts={echarts}
        option={options}
        opts={{renderer: 'svg', width: '280px', height: '300px'}}
      />
    );
    /*
    return (
      <ECharts
        option={options}
        opts={{renderer: 'svg', width: '280px', height: '300px'}}
      />
    );*/
  }
  return (
    <>
      {
        newsArr && magazineArr && tvArr && radioArr &&
        <section className="">
          <div className="section-header">
            <h5 className="title">광고통계</h5>
            <BtnText link={`/stat`} text="전체보기" rightIcon="chevron-right" color="gray"/>
          </div>
          <div className="section-body">
            <div className="thumbnail-wrap">
              <div className="thumbnail-card stats">
                <div className="row-box">
                  <div className="left-box">
                    <h4>월간 4대 매체 광고비</h4>
                    {
                      sMonth && sYear &&
                      <span>{`${sYear}.${sMonth}`}</span>
                    }
                  </div>
                </div>
                <Chart/>
              </div>
            </div>
          </div>
        </section>
      }
    </>
  )
}

export default HomePage;
